const top_splide = new Splide( '.mix-match-top', {
  type: 'loop',
  perPage: 3,
  perMove: 1,
  classes: {
    prev: 'splide__arrow--prev top-swiper-button-prev slider-button--prev swiper-button-prev',
    next: 'splide__arrow--next top-swiper-button-next slider-button--next swiper-button-next',
  },
  snap: true,
  gap: 60,
  breakpoints: {
    640: {
      perPage: 1,
      gap: 20,
      padding: 0,
      padding: '7rem',
    },
    768: {
      perPage: 2,
      gap: 40,
    }
  },
  speed: 400
});

const bottom_splide = new Splide( '.mix-match-bottom', {
  type: 'loop',
  perPage: 3,
  perMove: 1,
  classes: {
    prev: 'splide__arrow--prev bottom-swiper-button-prev slider-button--prev swiper-button-prev',
    next: 'splide__arrow--next bottom-swiper-button-next slider-button--next swiper-button-next',
  },
  snap: true,
  gap: 60,
  breakpoints: {
    640: {
      perPage: 1,
      gap: 20,
      padding: '7rem',
    },
    768: {
      perPage: 2,
      gap: 40,
    }
  },
  speed: 400
});

top_splide.mount();
bottom_splide.mount();

top_splide.on('moved', function (newIndex) {
  prevNextClick('top', '.top-set', newIndex)
});

bottom_splide.on('moved', function (newIndex) {
  prevNextClick('bottom', '.bottom-set', newIndex)
});

variantSelection('top', 0)
variantSelection('bottom', 0)

function prevNextClick(type, setType, dataMixIndex) {
  const productData = document.querySelectorAll(setType)

  productData.forEach(data => {
    data.classList.remove('active')
  })

  type === 'top' ?
    document.querySelector(`[data-mix-top="${ dataMixIndex }"]`).classList.add('active')
  :
    document.querySelector(`[data-mix-bottom="${ dataMixIndex }"]`).classList.add('active')

  const topPrice = document.querySelector('.mix-match-data .tops .active .mx-price').dataset.price
  const bottomPrice = document.querySelector('.mix-match-data .bottoms .active .mx-price').dataset.price

  priceCalc(topPrice, bottomPrice)
  variantSelection(type, dataMixIndex)
}

function variantSelection(type, dataMixIndex) {
  let variants_available

  if(type === 'top') {
    variants_available = document.querySelectorAll(`[data-mix-top="${ dataMixIndex }"] .size-var`)
    document.querySelector('.mix-match-tops-form .product-variant-id').value = ''
  } else {
    variants_available = document.querySelectorAll(`[data-mix-bottom="${ dataMixIndex }"] .size-var`)
    document.querySelector('.mix-match-bottoms-form .product-variant-id').value = ''
  }

  variants_available.forEach(variant => {
    variant.addEventListener('click', function() {
      variants_available.forEach(other_variants => {
        other_variants.className = 'size-var'
      })

      this.classList.add('selected')

      this.parentNode.parentNode.querySelector('.mx-label span:nth-child(2)').textContent = this.dataset.variant
      this.parentNode.parentNode.querySelector('.mx-label span:nth-child(1)').textContent = this.dataset.variantUs
      this.parentNode.parentNode.querySelector('.mx-label span:nth-child(3)').textContent = this.dataset.variantEu
      this.parentNode.parentNode.querySelector('input[type=hidden]').value = parseInt(this.dataset.variantId)

      type === 'top' ?
        document.querySelector('.mix-match-tops-form .product-variant-id').value = parseInt(this.dataset.variantId)
      :
        document.querySelector('.mix-match-bottoms-form .product-variant-id').value = parseInt(this.dataset.variantId)

      const topPrice = document.querySelector('.mix-match-data .tops .active .mx-price').dataset.price
      const bottomPrice = document.querySelector('.mix-match-data .bottoms .active .mx-price').dataset.price

      priceCalc(topPrice, bottomPrice)
    })
  })
}

const image_width = document.querySelector('.mix-match-sliders .splide__slide.is-active').offsetWidth

document.querySelector('.top-swiper-button-next').style.left = `${image_width}px`
document.querySelector('.bottom-swiper-button-next').style.left = `${image_width}px`
document.querySelector('.mix-match-seperate').style.left = `${image_width + 67}px`

const topPrice = document.querySelector('.mix-match-data .tops .active .mx-price').dataset.price
const bottomPrice = document.querySelector('.mix-match-data .bottoms .active .mx-price').dataset.price

priceCalc(topPrice, bottomPrice)

function priceCalc(top, bottom) {
  document.querySelector('.mx-total span').textContent = (parseFloat(top) + parseFloat(bottom))/100
}

document.querySelector('.mix-match-top .top-swiper-button-prev').addEventListener('click', function() {
  setTimeout(() => {
    prevNextClick('top', '.top-set', this.parentNode.parentNode.querySelector('.splide__slide.is-active').dataset.swiperSlideIndex)
  }, "600");
})

document.querySelector('.mix-match-top .top-swiper-button-next').addEventListener('click', function() {
  setTimeout(() => {
    prevNextClick('top', '.top-set', this.parentNode.parentNode.querySelector('.splide__slide.is-active').dataset.swiperSlideIndex)
  }, "600");
})

document.querySelector('.mix-match-bottom .bottom-swiper-button-prev').addEventListener('click', function() {
  setTimeout(() => {
    prevNextClick('bottom', '.bottom-set', this.parentNode.parentNode.querySelector('.splide__slide.is-active').dataset.swiperSlideIndex)
  }, "600");
})

document.querySelector('.mix-match-bottom .bottom-swiper-button-next').addEventListener('click', function() {
  setTimeout(() => {
    prevNextClick('bottom', '.bottom-set', this.parentNode.parentNode.querySelector('.splide__slide.is-active').dataset.swiperSlideIndex)
  }, "600");
})

// JS only add to cart
// document.querySelector('.mx-add-to-cart').addEventListener('click', function() {
//   const topId = document.querySelector('.mix-match-data .tops .active input[type=hidden]').value
//   const bottomId = document.querySelector('.mix-match-data .bottoms .active input[type=hidden]').value

//   console.log('topId', topId)

//   document.querySelector('.mx-add-to-cart span').classList.add('hidden')
//   document.querySelector('.mx-add-to-cart div').classList.remove('hidden')

//   const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')

//   // {% comment %} const config = fetchConfig('javascript');
//   // config.headers['X-Requested-With'] = 'XMLHttpRequest';
//   // delete config.headers['Content-Type'];

//   // const formData = new FormData(this.form);
//   // if (cart) {
//   //   formData.append(
//   //     'sections',
//   //     cart.getSectionsToRender().map((section) => section.id)
//   //   );
//   //   formData.append('sections_url', window.location.pathname);
//   //   cart.setActiveElement(document.activeElement);
//   // }

//   // config.body = formData; {% endcomment %}

//   // Mix & Match add to cart
//   fetch('/cart/add.js', {
//     body: JSON.stringify({
//       items: [
//         {
//           quantity: 1,
//           id: topId
//         },
//         {
//           quantity: 1,
//           id: bottomId
//         }
//       ],

//     }),
//     headers: {
//       'Content-Type': 'application/json',
//       'X-Requested-With': 'xmlhttprequest'
//     },
//     method: 'POST'})
//   .then((response) => response.json())
//   .then((response) => {
//     console.log('Mix and match added', response)
//     // {% comment %} const responseItems = response.items
//     // responseItems.forEach(item => {
//     //   {% comment %} item.push({'sections': 'data'}) {% endcomment %}
//     //   cart.renderContents(item);
//     // }) {% endcomment %}
//     // {% comment %} cart.renderContents(response); {% endcomment %}
//   })
//   .catch((err) => console.error(err))
//   .finally(() => {
//     // Hiding the loading animation in add to cart button
//     document.querySelector('.mx-add-to-cart div').classList.add('hidden')
//     document.querySelector('.mx-add-to-cart span').classList.remove('hidden')
//     // {% comment %} cart.classList.add('active') {% endcomment %}

//     // Updating Cart Drawer
//     const cartItemContainer = document.querySelector('.main-cart-items')

//     // Updating the Count
//     if(document.querySelector('.cart-count-bubble')) {
//       let cart_count = document.querySelector('.cart-count-bubble > span:first-child').textContent
//       cart_count = cart_count.replace(/[()]/g,'')
//       document.querySelector('.cart-count-bubble > span:first-child').textContent = `(${parseInt(cart_count) + 2})`
//     } else {
//       document.querySelector('#cart-icon-bubble').innerHTML += `<div class="cart-count-bubble"><span aria-hidden="true">(2)</span></div>`
//     }

//     // Displaying the Cart Drawer
//     cart.classList.add('active')
//   });
// })

document.querySelector('.price-in-au').addEventListener('click', function() {
  document.querySelector('.mix-match-data').className = 'mix-match-data show-au-price'
})

document.querySelector('.price-in-us').addEventListener('click', function() {
  document.querySelector('.mix-match-data').className = 'mix-match-data show-us-price'
})

document.querySelector('.price-in-eu').addEventListener('click', function() {
  document.querySelector('.mix-match-data').className = 'mix-match-data show-eu-price'
})

document.querySelector('.mx-add-to-cart').addEventListener('click', function() {
  const top_selected_id = document.querySelector('.mix-match-tops-form .product-variant-id').value
  const bottom_selected_id = document.querySelector('.mix-match-bottoms-form .product-variant-id').value

  if(top_selected_id !== '' && bottom_selected_id !== '') {
    const _tops = document.querySelector('.mix-match-tops-form button')
    const _bottoms = document.querySelector('.mix-match-bottoms-form button')

    _tops.click();

    setTimeout(() => {
      _bottoms.click();
    }, "1000");
  } else if(top_selected_id !== '') {
    document.querySelector('.mx-message').textContent = 'Please select bottom size'
  } else if(bottom_selected_id !== '') {
    document.querySelector('.mx-message').textContent = 'Please select top size'
  } else {
    document.querySelector('.mx-message').textContent = 'Please select top and bottom sizes'
  }
})